<footer class="footer py-1 bg-dark text-white-50">
    <div class="footer-copyright text-center py-3">© 2020.
        <a href="http://www.lasistemas.com"><b>LA Sistemas.</b></a>
         Todos los Derechos Reservados.
    </div>
</footer>
